// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cwgy","top":"styles_top__1xHxf","left":"styles_left__k-sck","description":"styles_description__1uA_1"};